export { default as WishketServiceTerms } from './Wishket';
export { default as WishketJobsServiceTerms } from './WishketJobs';
